import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {DeleteModal} from "components";
import {MainInfo} from "fragments";
import {AddVehicle} from "./fragments";
import {emptyState, vehiclesBody, vehiclesHead} from "./constants";
import {VehicleSingle} from "./vehicleSingle";
import {httpRequestsOnSuccessActions, vehiclesActions} from "store";
import {FindSuccess, limit, useModal} from "utils";

const ACTION_TYPE = "GET_VEHICLES";
const ACTION_DELETE = "DELETE_VEHICLE";
const ACTION_CHANGE_STATUS = "CHANGE_STATUS_VEHICLE";

export const Vehicles = () => {
    const vehiclesList = useSelector((state) => state.vehicles?.vehiclesList);
    const dispatch = useDispatch();
    const location = useLocation();
    const {openModal, close} = useModal();
    const successChangeStatus = FindSuccess(ACTION_CHANGE_STATUS);
    const info = location?.state;

    const getVehicles = (noLoad) => {
        const params = {
            ...info,
        };
        params.skip = info?.skip ? info?.skip : 0;
        params.limit = limit;

        dispatch(vehiclesActions.getVehicles(params, noLoad));
    }

    useEffect(() => {
        if (successChangeStatus?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_CHANGE_STATUS));
            getVehicles(true)
        }
    }, [successChangeStatus]);

    useEffect(() => {
        getVehicles()
    }, [info]);

    const addVehicle = (item) => {
        openModal(<AddVehicle info={item} afterSuccess={() => getVehicles(true)}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 482
        });
    };

    const handleDelete = (item) => {
        openModal(
            <DeleteModal
                handleDelete={() => {
                    dispatch(vehiclesActions.deleteVehicle(item?.id));
                }}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${item?.make} ${item?.modelName} ?`}
                afterSuccess={() => {
                    getVehicles(true);
                    close();
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const handleClickRow = (item) => {
        openModal(<VehicleSingle item={item} afterSuccess={() => getVehicles(true)}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 1015
        });
    };

    return (
        <div className="vehicles-page-wrapper">
            <MainInfo
                buttonText="Add Vehicle"
                headerTable={vehiclesHead()}
                bodyTable={vehiclesBody({
                    handleDelete,
                    handleEit: (item) => addVehicle(item),
                })}
                clickToAddButton={() => addVehicle()}
                listTable={vehiclesList?.vehicles}
                listCountTable={vehiclesList?.count}
                actionType={ACTION_TYPE}
                handleClickRow={handleClickRow}
                emptyState={emptyState(addVehicle)}
            />
        </div>
    );
};
